import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator, Text } from '@chakra-ui/react';
import React from 'react';
import { styles } from './breadcrumbs.styles';
const Breadcrumbs = ({ paths, onCrumbClick, isPrimary })=>{
    const classes = styles();
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx(Breadcrumb, {
            spacing: '16px',
            separator: /*#__PURE__*/ _jsx(BreadcrumbSeparator, {
                sx: classes.separator,
                children: "/"
            }),
            children: paths?.map((path, idx)=>/*#__PURE__*/ _jsx(BreadcrumbItem, {
                    children: /*#__PURE__*/ _jsx(BreadcrumbLink, {
                        style: {
                            textDecoration: 'none'
                        },
                        isCurrentPage: idx === paths.length - 1,
                        onClick: ()=>{
                            if (idx < paths.length - 1 && path.link) onCrumbClick(path?.data);
                        },
                        children: /*#__PURE__*/ _jsx(Text, {
                            sx: idx < paths.length - 1 || isPrimary && idx < 2 ? classes.defaultText : classes.activeText,
                            children: path.displayName
                        })
                    })
                }))
        })
    });
};
Breadcrumbs.displayName = 'New Breadcrumbs';
export { Breadcrumbs };
